module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/call/call-1392151c3ca0ab2dbf04b7e7acbda443.gif";